var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{class:`btn-${ _vm.variant }`,attrs:{"id":"submit-button","disabled":_vm.isDisabled || _vm.isFetching},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.isFetching)?_c('b-spinner',{attrs:{"id":"spinner"}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.GetText()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }